import { api } from "./api";

export const ProfissionalService = {

  async findAll() {
    const response = await api.get("/profissionais");
    const data = response.data;

    if (Array.isArray(data)) {
      return data;
    }

    if (Array.isArray(data?.data)) {
      return data.data;
    }

    return [];
  },

  async create(data: any) {
    const response = await api.post("/profissionais", data);
    return response.data;
  },

  async update(id: number, data: any) {
    const response = await api.put(`/profissionais/${id}`, data);
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/profissionais/${id}`);
    return response.data;
  }
};
